import { StringMax255 } from "aws-sdk/clients/discovery";

export interface CHAPTER {
  id: number | string;
  chapter_name: string;
  chapter_sign: string;
  chapter_founding_date: string | Date;
  chapter_status: string;
  school_website: string;
  school_logo: string;
}

export type CREATE_CHAPTER_FORM = Omit<CHAPTER, "id">;

export interface MEMBER {
  id: number | string;
  full_name: string;
  email: string;
  date_of_birth: string | Date;
  chapter: string;
  member_class: string;
  member_status: string;
  national_board_active_member: boolean;
  omega_status: boolean;
  og_founding_father: boolean;
}

export type CREATE_MEMBER_FORM = Omit<MEMBER, "id">;

export interface EVENT_POST {
  id: number | string;
  event_title: string;
  event_start_date: string | Date;
  event_end_date: string | Date;
  event_body: string;
  event_image: string;
  event_to_display: boolean | string;
}

export type CREATE_EVENT_POST_FORM = Omit<EVENT_POST, "id">;

export interface NEWS_POST {
  id: number | string;
  news_title: string;
  news_publish_date: string | Date;
  news_body: string;
  news_image: string;
  news_to_display: boolean;
}

export type CREATE_NEWS_POST_FORM = Omit<NEWS_POST, "id">;

export interface NB_MEMBER {
  id: number | string;
  member_name: string;
  position_name: string;
  email_address: string;
  chapter_member: string;
  class_member: string;
  member_pic: string;
}

export type CREATE_NB_MEMBER_FORM = Omit<NB_MEMBER, "id">;

export interface CAROUSEL_POST {
  id: number | string;
  carousel_post_title: string;
  carousel_post_start_date: string | Date;
  carousel_post_end_date: string | Date;
  carousel_post_body: string;
  carousel_post_image: string;
  carousel_postt_to_display: boolean;
}

export type CREATE_CAROUSEL_POST_FORM = Omit<CAROUSEL_POST, "id">;

export interface SCHOLARSHIP_FORM {
  id: number | string;
  full_name: string;
  date_of_birth: string | Date;
  email_address: string;
  phone_number: string;
  gpa: string;
  intended_major: string;
  intended_university: string;
  question_one: string;
  question_two: string;
  question_three: string;
  unofficial_transcripts: string;
}

export type CREATE_SCHOLARSHIP_FORM = Omit<SCHOLARSHIP_FORM, "id">;

export type InterestForm = {
  id: number;
  full_name: string;
  phone_number: string;
  email_address: string;
  major: string;
  school: string; // lowercased field
};

export type CreateInterestForm = Omit<InterestForm, "id">;

// Keep this single source of truth for the dropdown + admin tabs
export const SCHOOL_OPTIONS = [
  "San Jose State University",
  "University of Southern California",
  "California State University, Fresno",
  "University of Nevada, Las Vegas",
  "California State University, Sacramento",
  "University of California, Irvine",
  "California State University, Fullerton",
  "University of California, Riverside",
  "University of California, Merced",
  "University of California, Davis",
  "University of California, Santa Barbara",
  "California State Polytechnic University, Pomona",
] as const;
